const focusElement = selector => {
  if (!selector) return;
  const element = typeof selector === 'string' || selector instanceof String ? document.querySelector(selector) : selector;

  if (element) {
    if (!/^(a|select|input|button|textarea)/i.test(element.tagName.toLowerCase())) {
      element.setAttribute('tabindex', -1);
    }

    element.focus();
  }
};

export default focusElement;